import React, { useCallback, useEffect } from 'react';
import * as auth from 'ducks/auth';
import { Redirect, Route as ReactRoute } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { BASE_APP_PATH } from './constants';
import { TermsAgreement } from 'new-design/components/TermsAgreement';
import { useQueryParams } from 'new-design/hooks/useQueryParams';
import { bindActionCreators } from 'redux';

const SsoRoute = ({ component: Component, ...rest }) => {
  const { sessionID } = useQueryParams();

  const { requestSessionInfo } = bindActionCreators(auth.actions, useDispatch());

  const { sessionID: authorizedSessionID, termsInfo } = useSelector(auth.selectors);

  useEffect(() => {
    if (sessionID) {
      requestSessionInfo(sessionID);
    }
  }, []);

  const renderHandler = useCallback(
    (props) => {
      return authorizedSessionID && !termsInfo?.acceptRequired && !termsInfo?.termsChanged ? (
        <Redirect to={{ pathname: BASE_APP_PATH }} />
      ) : (
        <>
          <Component {...props} />
          <TermsAgreement />
        </>
      );
    },
    [authorizedSessionID, termsInfo]
  );

  return <ReactRoute {...rest} render={renderHandler} />;
};

export { SsoRoute };
